import React from "react";
import { useTranslation } from "react-i18next";

// common
import Modal, { ModalText, ModalLayout, MoreModalButtons } from "common/modal";

const { ConfirmationText } = ModalText;
const { ModalRow } = ModalLayout;
const { ModalButtonYellow, ButtonContainer } = MoreModalButtons;

type TProps = {
  visible: boolean;
  onCloseModal: () => void;
};

const NoMeetingLinkModal = ({ visible, onCloseModal }: TProps) => {
  const { t } = useTranslation("book_a_class");

  return (
    <Modal
      title={t("CLASS NOT READY")}
      centered
      visible={visible}
      footer={null}
      onCancel={onCloseModal}
    >
      <ConfirmationText>
        {t(
          "The meeting link for your class has not been sent by your teacher yet, please wait a bit. In case your teacher shows up late, please email us on"
        )}{" "}
        <a href="mailto:support@flexiclasses.com">support@flexiclasses.com</a>
      </ConfirmationText>
      <ModalRow>
        <ButtonContainer xs={18}>
          <ModalButtonYellow type="primary" onClick={() => onCloseModal()}>
            {t("OKAY")}
          </ModalButtonYellow>
        </ButtonContainer>
      </ModalRow>
    </Modal>
  );
};

export default NoMeetingLinkModal;
